export class Notification {
  constructor({
    id,
    type,
    recipientId,
    senderId = null,
    sender = null,
    postId = null,
    activity = null,
    read = false,
    createdAt
  }) {
    this.id = id;
    this.type = type;
    this.recipientId = recipientId;
    this.senderId = senderId;
    this.sender = sender;
    this.postId = postId;
    this.activity = activity;
    this.read = read;
    this.createdAt = createdAt;
  }
} 